import { Button, Modal } from "antd";
import { Navigate } from "react-router-dom";
import { useState } from "react";
import AddAnnouncement from "./AddAnnouncement";
import GetAllAnnouncement from "./GetAllAnnouncement";
import { Col, Row } from "antd";
import "./Announcement.css";

const Announcement = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const [editData, setEditData] = useState(null);
	const [modalOpen, setModalOpen] = useState(false);

	const handleSetEditData = (data) => {
		setEditData(data);
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
		setEditData(null);
	};

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	return (
		<div className="announcement-page-container">
			<div className="flex justify-between items-center mb-4">
				<span />
				<Button type="primary" className="announcement-apply-btn" onClick={() => { setEditData(null); setModalOpen(true); }}>
					Add Announcement
				</Button>
			</div>
			<Row gutter={16} className="announcement-row">
				<Col span={24} className="announcement-list-col">
					<GetAllAnnouncement setEditData={handleSetEditData} />
				</Col>
			</Row>
			<Modal
				title={editData ? "Edit Announcement" : "Add Announcement"}
				open={modalOpen}
				onCancel={handleCloseModal}
				footer={null}
				width={560}
				destroyOnClose
			>
				<AddAnnouncement editData={editData} setEditData={setEditData} onCancel={handleCloseModal} />
			</Modal>
		</div>
	);
};

export default Announcement;